import React from "react";
import { motion } from "framer-motion";
import {
  Hourglass, UserCheck, Zap, Target, MapPinned, Scale,
} from "lucide-react";

const ITEMS = [
  { icon: Hourglass, title: "+40 Años de Trayectoria", desc: "Décadas de práctica profesional respaldan cada dictamen y avalúo que emitimos." },
  { icon: UserCheck, title: "Atención Personalizada", desc: "Cada cliente recibe seguimiento directo con Angel Rodríguez, sin intermediarios." },
  { icon: Zap,       title: "Respuesta Rápida",      desc: "Cotización en menos de 24 horas. Tiempos de entrega competitivos y cumplidos." },
  { icon: Target,    title: "Precisión Técnica",     desc: "Metodología certificada, actualizada y alineada a estándares nacionales e institucionales." },
  { icon: MapPinned, title: "Cobertura Regional",    desc: "Servicio en Puebla, Cholula, Atlixco, Tehuacán y toda la región Puebla–Tlaxcala." },
    { icon: Scale,     title: "Seguridad Jurídica",    desc: "Documentos con plena validez legal, listos para trámites notariales, fiscales y judiciales." },
];

export default function WhyUs() {
  return (
    <section
      id="por-que-elegirnos"
      data-testid="why-us-section"
      className="relative bg-brand-navy text-white py-24 lg:py-32 overflow-hidden"
    >
      <div aria-hidden className="absolute inset-0 bg-blueprint-dark bg-grid-40 opacity-60" />
      <div aria-hidden className="absolute -top-32 -right-32 w-[480px] h-[480px] rounded-full border border-brand-gold/15" />
      <div aria-hidden className="absolute -bottom-40 -left-40 w-[520px] h-[520px] rounded-full border border-brand-gold/10" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3">
            <span className="h-px w-10 bg-brand-gold" />
            <span className="label-overline">Por Qué Elegirnos</span>
          </div>
          <h2 className="mt-5 font-playfair text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1] tracking-tight text-balance">
            La diferencia está en la <span className="italic text-brand-gold">experiencia</span> y el compromiso
          </h2>
          <p className="mt-5 font-inter text-lg text-white/70 leading-relaxed max-w-2xl">
            Más de cuatro décadas avalan cada documento que firmamos. Trabajamos con rigor
            técnico, transparencia total y un trato cercano que nuestros clientes valoran.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {ITEMS.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.08, ease: "easeOut" }}
              className="group relative p-7 lg:p-8 border border-white/10 hover:border-brand-gold/60 bg-white/[0.02] hover:bg-white/[0.04] transition-all duration-300"
              data-testid={`why-us-card-${i}`}
            >
              <span className="absolute top-0 left-0 h-[2px] w-12 bg-brand-gold group-hover:w-24 transition-all duration-300" />
              <div className="flex h-12 w-12 items-center justify-center border border-brand-gold/40 rounded-sm">
                <it.icon size={22} strokeWidth={1.5} className="text-brand-gold" />
              </div>
              <h3 className="mt-5 font-playfair text-xl text-white">{it.title}</h3>
              <p className="mt-2.5 font-inter text-sm leading-relaxed text-white/65">{it.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
